type GetTokenFn = () => Promise<string | null>;

let _getClerkToken: GetTokenFn | null = null;

export function registerClerkTokenProvider(getToken: GetTokenFn) {
  _getClerkToken = getToken;
}

export function clearClerkTokenProvider() {
  _getClerkToken = null;
}

export function hasClerkTokenProvider(): boolean {
  return _getClerkToken !== null;
}

export async function getClerkTokenForApi(): Promise<string | null> {
  if (!_getClerkToken) return null;
  return _getClerkToken();
}
